import { ClaimDetails } from '../../layouts/ClaimDetails/ClaimDetails';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$retailer/claim-details')({
  component: ClaimDetails,
});
